import * as React from 'react';

const Refine = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.91 6C4.7 5.42 4.14999 5 3.5 5C2.85001 5 2.3 5.42 2.09 6H0V7H2.09C2.3 7.58 2.85001 8 3.5 8C4.14999 8 4.7 7.58 4.91 7H16V6H4.91ZM12.5 10.5C11.85 10.5 11.3 10.92 11.09 11.5H0V12.5H11.09C11.3 13.08 11.85 13.5 12.5 13.5C13.15 13.5 13.7 13.08 13.91 12.5H16V11.5H13.91C13.7 10.92 13.15 10.5 12.5 10.5ZM5.09 17C5.3 16.42 5.85001 16 6.5 16C7.14999 16 7.7 16.42 7.91 17H16V18H7.91C7.7 18.58 7.14999 19 6.5 19C5.85001 19 5.3 18.58 5.09 18H0V17H5.09Z"
            fill="currentColor"
        />
    </svg>
);

export default Refine;
